import React, { useEffect, useState, Fragment } from "react";
import { Tab, Transition } from '@headlessui/react'
import { Remarkable } from 'remarkable';
import { formatDate } from "@/lib/formatDate"
import ReactPaginate from 'react-paginate';
import Link from 'next/link';
import Image from "next/image";

export function CaseStudiesList({ blogs }) {

  const blogsortByDateCreated = blogs.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });

  const blogFiltered = blogsortByDateCreated.filter((data) => {
    return data
  })

  const [item, setItem] = useState(blogFiltered)
  const [currentKey, setCurrentKey] = useState('industries')
  const [ fLabel, setFLabel ] = useState('')
  const industries = blogFiltered.map((Val) => Val.industries)
  const regions = blogFiltered.map((Val) => Val.regions)
  const usecases = blogFiltered.map((Val) => Val.usecases)
  const services = blogFiltered.map((Val) => Val.services)

  const industriesItems = [...new Set(industries.flat(1))]
  const regionsItems = [...new Set(regions.flat(1))]
  const usecasesItems = [...new Set(usecases.flat(1))]
  const servicesItems = [...new Set(services.flat(1))]

  const filterIndustry = (curcat) => {
    const newItem = blogFiltered.filter((blog) => {
      if (blog.industries) {
        setItem(blogs)
        return blog.industries.some(flag => flag === curcat)
      }
      return false
    })
    setCurrentKey('industries')
    setItem(newItem)
  }
  const filterRegion = (curcat) => {
    const newItem = blogFiltered.filter((blog) => {
      if (blog.regions) {
        setItem(blogs)
        return blog.regions.some(flag => flag === curcat)
      }
      return false
    })
    setCurrentKey('regions')
    setItem(newItem)
  }
  const filterUseCase = (curcat) => {
    const newItem = blogFiltered.filter((blog) => {
      if (blog.usecases) {
        setItem(blogs)
        return blog.usecases.some(flag => flag === curcat)
      }
      return false
    })
    setCurrentKey('usecases')
    setItem(newItem)
  }
  const filterService = (curcat) => {
    const newItem = blogFiltered.filter((blog) => {
      if (blog.services) {
        setItem(blogs)
        return blog.services.some(flag => flag === curcat)
      }
      return false
    })
    setCurrentKey('services')
    setItem(newItem)
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = item.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = ({ selected }) => {
    const element = document.getElementById('allCaseStudies');
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
      });
    }
    setCurrentPage(selected + 1);
  };
  console.log(fLabel)
  return (
    <div className="max-w-8xl min-w-full w-full md:px-4">
      <Tab.Group>
        <div className="flex justify-start gap-4 pb-8 w-full border-b " id="allCaseStudies">
          <button className="medium-title text-left hover:text-orange-400" onClick={() => { setItem(blogFiltered), setCurrentPage(1) }}>
            All Case Studies
          </button>
        </div>
        <Tab.List className="blog-categories py-4 border-b " >
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={
                  selected ? 'active-filter' : 'active-filter'
                }
              >
                <Image width={24} height={24} className="h-4 pr-2" src="/assets/images/layout/building.svg" alt="Filter by Industry" />Industry
              </button>
            )}
          </Tab>
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={
                  selected ? 'active-filter' : 'active-filter'
                }
              >
                <Image width={24} height={24} className="h-4 pr-2" src="/assets/images/layout/fingerprint.svg" alt="Filter by Use Case" />Use Case
              </button>
            )}
          </Tab>
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={
                  selected ? 'active-filter' : 'active-filter'
                }
              >
                <Image width={24} height={24} className="h-4 pr-2" src="/assets/images/layout/supermarket.svg" alt="Filter by Service" />Service
              </button>
            )}
          </Tab>
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={
                  selected ? 'active-filter' : 'active-filter'
                }
              >
                <Image width={24} height={24} className="h-4 pr-2" src="/assets/images/layout/placeholder.svg" alt="Filter by Region" />Region
              </button>
            )}
          </Tab>
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel>
            <div className="service-item">
              {industriesItems.sort().map((Val, id) => {
                return (
                  <button
                    className="btn-filter"
                    onClick={() => { filterIndustry(Val); setFLabel(Val)}}
                    key={id}
                  >
                    {Val}
                  </button>
                );
              })}
            </div>
          </Tab.Panel>
          <Tab.Panel>
            <div className="service-item">
              {usecasesItems.sort().map((Val, id) => {
                return (
                  <button
                    className="btn-filter"
                    onClick={() => {filterUseCase(Val); setFLabel(Val)}}
                    key={id}
                  >
                    {Val}
                  </button>
                );
              })}
            </div>
          </Tab.Panel>
          <Tab.Panel>
            <div className="service-item">
              {servicesItems.sort().map((Val, id) => {
                return (
                  <button
                    className="btn-filter"
                    onClick={() => {filterService(Val); setFLabel(Val)}}
                    key={id}
                  >
                    {Val}
                  </button>
                );
              })}
            </div>
          </Tab.Panel>
          <Tab.Panel>
            <div className="service-item">
              {regionsItems.sort().map((Val, id) => {
                return (
                  <button
                    className="btn-filter"
                    onClick={() => {filterRegion(Val); setFLabel(Val)}}
                    key={id}
                  >
                    {Val}
                  </button>
                );
              })}
            </div>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-2 min-w-full mt-8">
        {currentPosts.map((blog, key) => (
          <article key={blog.urlPath} className="mt-8 min-w-full shrink-0 group">
            <div className="grid grid-cols-1 text-start ">
              <Link href={`../${blog.urlPath}`} className="overflow-hidden  h-full rounded-lg">
                <Image width={640} height={360} src={blog.image} className="!aspect-[16/9] h-full rounded-lg object-cover w-full shadow-xl ease-in duration-500 group-hover:scale-105 transform bypass-filter" alt="Case Study" />
              </Link>
              <div className="flex items-center gap-4 mt-4 text-xs">
                <div className="text-[#556987] text-sm font-medium uppercase text-orange-400 font-semibold md:font-bold">
                  {fLabel ? fLabel : blog[currentKey][0]}
                </div>
                <span className="text-gray-500">
                  {blog?.readingTime ? blog.readingTime + " min read" : "0 min read"}
                </span>
              </div>
              <div className="min-w-full w-full">
                <Link className="mt-2 h-[4.1rem] min-h-[4.1rem] line-clamp-2 text-[#2A3342] text-2xl font-bold w-full min-w-full group-hover:text-orange-400 transition ease-in-out capitalize" href={`../${blog.urlPath}`} >{blog.title}</Link>
              </div>
              <div className="pt-2 text-justify text-secgray font-regular">{blog.description}</div>
            </div>
            {/*<div className="relative mt-8 flex items-center gap-x-4 text-start">
                    <img src={blog.avatarUrl} alt="Author Image" className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover" />
                    <div className="text-sm leading-6">
                      <p className="font-semibold text-maingray">
                        <span className="" />
                        {blog.authors[0]}
                      </p>
                      <time dateTime={blog.created} className="text-secgray">
                        {new Date(blog.created).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                      </time>
                    </div>
                  </div>*/}

          </article>
        ))}

        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(item.length / postsPerPage)}
          previousLabel={'Prev'}
          nextLabel={'Next'}
          containerClassName={'pagination'}
          pageLinkClassName={'page-number'}
          previousLinkClassName={'page-number'}
          nextLinkClassName={'page-number'}
          activeLinkClassName={'active-page'}
        />

      </div>
    </div >
  )
}

export default function CaseStudies({ casestudies }) {
  return (
    <div>
      <section className="flex justify-center container mx-auto
    mt-24 px-8 md:px-4">
        <div className="flex flex-col gap-5 max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl items-center font-['Inter'] text-center px-4">
          <h2 className="main-top-title">Case Studies
          </h2>
          <p className="font-medium text-xl text-[#556987]"></p>
          <CaseStudiesList blogs={casestudies} />
        </div>
      </section>
    </div>
  )
}